module.exports = __webpack_public_path__ + "img/gyg_logo.d996070.png";